const Arbitrum = () => (
    <svg
        width='36'
        height='40'
        viewBox='0 0 36 40'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        id='arbitrum'
    >
        <path
            d='M18.1074 25.8088L23.4649 34.4681L28.4138 31.5144L21.3782 20.0938L18.1074 25.8088Z'
            fill='white'
        />
        <path
            d='M32.9225 28.0406L32.9189 25.6747L25.2309 13.3428L22.377 18.3263L29.7987 30.6879L32.4835 29.0865C32.6135 28.978 32.7198 28.8424 32.7955 28.6888C32.8712 28.5351 32.9145 28.3667 32.9228 28.1946L32.9225 28.0406Z'
            fill='white'
        />
        <path
            d='M0.705078 30.2725L4.49455 32.5213L17.1049 11.6943L14.9648 11.6372C13.1413 11.6107 11.177 12.0987 10.2755 13.6147L3.1145 25.0452L0.706463 28.8572V30.2737L0.705078 30.2725Z'
            fill='white'
        />
        <path
            d='M24.3823 11.6938L18.7419 11.7149L5.98047 33.4026L10.4409 36.0476L11.6537 33.9288L24.3823 11.6938Z'
            fill='white'
        />
        <path
            d='M35.2977 11.6643C35.2719 11.0648 35.1049 10.4808 34.8111 9.96261C34.5173 9.44441 34.1055 9.00758 33.6113 8.68979L19.5888 0.385075C19.0882 0.131735 18.5378 0 17.9801 0C17.4223 0 16.872 0.131735 16.3714 0.385075C16.2543 0.445792 2.73473 8.52103 2.73473 8.52103C2.54689 8.61392 2.36723 8.72341 2.19777 8.84827C1.75878 9.16977 1.39623 9.58953 1.13736 10.076C0.878494 10.5625 0.730031 11.1031 0.703125 11.6572V28.8567L3.11116 25.0446L3.09261 11.7743C3.10388 11.5924 3.15418 11.4153 3.2399 11.2558C3.32562 11.0963 3.44462 10.9583 3.58834 10.8519C3.652 10.8049 17.4024 2.60791 17.4462 2.58539C17.6108 2.50287 17.7913 2.45956 17.9744 2.45868C18.1575 2.45779 18.3384 2.49934 18.5038 2.58026L32.345 10.7798C32.5062 10.8852 32.6404 11.029 32.7362 11.1991C32.8321 11.3692 32.8868 11.5605 32.8958 11.7569V28.1965C32.8924 28.3669 32.8538 28.5347 32.7824 28.6885C32.7111 28.8423 32.6086 28.9786 32.482 29.0884L29.7972 30.6898L28.4132 31.5165L23.4643 34.4702L18.4454 37.4658C18.1679 37.5666 17.8643 37.5604 17.5909 37.4484L11.653 33.9311L10.4402 36.0497L15.7766 39.2137C15.9532 39.3169 16.1104 39.4087 16.2394 39.4834C16.4392 39.5974 16.5754 39.6758 16.6233 39.6997C17.0697 39.9012 17.5524 40.0035 18.0399 39.9999C18.4869 40.0006 18.9301 39.9147 19.3463 39.7468L33.9238 31.0527C34.335 30.7232 34.6711 30.3049 34.9084 29.8272C35.1457 29.3494 35.2784 28.8239 35.2972 28.2877L35.2977 11.6643Z'
            fill='white'
        />
    </svg>
);

export default Arbitrum;
